export default __webpack_public_path__ + "static/media/background-mobile.378a064e.jpg";